import { createApp, reactive } from 'vue';

import router from './router';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome, faInfoCircle, faPhone, faWifi,
  faDatabase, faBell, faSolarPanel, faLocationDot
} from '@fortawesome/free-solid-svg-icons';

import '@mdi/font/css/materialdesignicons.css';

import App from './App.vue';
import './assets/styles.css';
import './assets/menu.css';

const savedTheme = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: savedTheme,
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#FFFFFF',
          surface: '#FFFFFF',
          primary: '#0069ad',
          secondary: '#004a7a',
        },
      },
      dark: {
        dark: true,
        colors: {
          background: '#101720',
          surface: '#17212E',
          primary: '#0069ad',
          secondary: '#004a7a',
        },
      },
    },
  },
});

library.add(
  faHome, faInfoCircle, faPhone, faWifi,
  faDatabase, faBell, faSolarPanel, faLocationDot
);

const globalState = reactive({
  drawer: true,
  miniVariant: true,
});


document.documentElement.classList.toggle('dark-mode', savedTheme === 'dark');


const app = createApp(App);
app.provide('globalState', globalState);

app
  .use(vuetify)
  .use(router)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app');


router.beforeEach((to, from, next) => {
  const isLogin = to.name === 'Login';
  const theme = vuetify.theme;

  if (isLogin) {
    sessionStorage.setItem('userPrevTheme', theme.global.name.value);

    theme.global.name.value = 'light';
    document.documentElement.classList.remove('dark-mode');
  } else {
    const prev = sessionStorage.getItem('userPrevTheme');
    if (prev && prev !== theme.global.name.value) {
      theme.global.name.value = prev;
      document.documentElement.classList.toggle('dark-mode', prev === 'dark');
    }
  }
  next();
});